import { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';

import {
  Button,
  Box,
  BottomNavigation,
  BottomNavigationAction,
  Grid,
} from '@mui/material';

import { QuestionAnswer, Chat } from '@mui/icons-material';

import TicketsManagerTabs from '../../components/TicketsManagerTabs';
import Ticket from '../../components/Ticket';

import { TicketsContext } from '../../context/Tickets/TicketsContext';

import { i18n } from '../../translate/i18n';
import { QueueSelectedProvider } from '../../context/QueuesSelected/QueuesSelectedContext';
import { getStyled } from './styles';

const TicketAdvanced = () => {
  const classes = getStyled();
  const { ticketId } = useParams();
  const [option, setOption] = useState(0);
  const { currentTicket, setCurrentTicket } = useContext(TicketsContext);

  useEffect(() => {
    const setOptions = async () => {
      if (currentTicket.id !== null) {
        setCurrentTicket((prev) => ({ ...prev, code: '#open' }));
      }
      if (!ticketId) {
        setOption(1);
      }

      return () => {
        setCurrentTicket({ id: null, code: null });
      };
    };
    setOptions();
  }, [ticketId]); //eslint-disable-line

  useEffect(() => {
    const setOption = async () => {
      if (currentTicket.id !== null) {
        setOption(0);
      }
    };
    setOption();
  }, [currentTicket.id]);

  const renderPlaceholder = () => {
    return (
      <Box style={classes.placeholderContainer}>
        <div style={classes.placeholderItem}>
          {i18n.t('chat.noTicketMessage')}
        </div>
        <br />
        <Button onClick={() => setOption(1)} variant='outlined' color='primary'>
          Selecionar Ticket
        </Button>
      </Box>
    );
  };

  const renderMessageContext = () => {
    if (ticketId && ticketId !== 'undefined') {
      return <Ticket />;
    }
    return renderPlaceholder();
  };

  const renderTicketsManagerTabs = () => {
    return <TicketsManagerTabs />;
  };

  return (
    <QueueSelectedProvider>
      <Grid style={classes.grid}>
        <Box style={classes.header}>
          <BottomNavigation
            value={option}
            onChange={(newValue) => {
              setOption(newValue);
            }}
            showLabels
            style={classes.root}
          >
            <BottomNavigationAction label='Ticket' icon={<Chat />} />
            <BottomNavigationAction
              label='Atendimentos'
              icon={<QuestionAnswer />}
            />
          </BottomNavigation>
        </Box>
        <Box style={classes.content}>
          {option === 0 ? renderMessageContext() : renderTicketsManagerTabs()}
        </Box>
      </Grid>
    </QueueSelectedProvider>
  );
};

export default TicketAdvanced;
